import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import Page from '../../components/page'
import Header from '../../components/header'
import Wrapper from '../../components/wrapper'
import Clearfix from '../../components/clearfix'
import Title from '../../components/title'
import Footer from '../../components/footer'
import Button from '../../components/button'

import { thanks } from '../../state/actions/stepActions'
import { pushRoute } from '../../utils'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import {
  FetchPOSOnboardDetails
} from '../../state/api'

class EndOfTheRide extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Nome: ''
    }
  }
componentWillMount(){
  const { dispatch, step } = this.props
  let body={
    GUID:this.props.step.guid
  }
  FetchPOSOnboardDetails('OnboardRequestDetails/FetchPOSOnboardingDetails', body).then(json => {
  this.setState({
    Nome: (!!json.payLoad && json.payLoad.FirstName)? json.payLoad.FirstName:""
  })
  });
}
  componentDidMount() {
    const { dispatch, step } = this.props
    if (!step || !step.number) {
      dispatch(thanks(this.props.guid))
    }
    // let body={
    //   GUID:this.props.step.guid
    // }
    // FetchPOSOnboardDetails('OnboardRequestDetails/FetchPOSOnboardingDetails', body).then(json => {
    // this.setState({
    //   Nome: (!!json.payLoad && json.payLoad.FirstName)? json.payLoad.FirstName:""
    // })
    // });
  }

  getTitleText() {
    const { partnership, convention } = this.props.routing

    if (partnership === 'HYPE' && convention === 'YOOX')
      return 'Grazie, ci sei quasi!'

    if (partnership === 'HYPE4TIM')
      return `Grazie${
        !this.props.isParent ? ' per aver scelto la carta TIMpersonal!' : '!'
      }`

    return `Grazie ${
      !this.props.isParent ? ' '+this.state.Nome+', per aver inoltrato la tua richiesta' : '!'
    }`
  }

  getSubtitleText() {
    const { partnership } = this.props.routing
    const { isParent, guid } = this.props

    if (!isParent) {
      if (!!guid) {
        if (partnership === 'HYPE4TIM')
          return "Tieni sott'occhio la tua email, ti invieremo a breve le istruzioni per proseguire."

        return 'Hai completato la tua richiesta di registrazione!'
      } else {
        if (partnership === 'HYPE4TIM')
          return 'La tua richiesta è completa, adesso tocca a noi.'

        return "Tieni d'occhio la tua email, riceverai presto informazioni sullo stato della tua richiesta" //'Hai completato la tua richiesta di registrazione. La stiamo già processando!'
      }
    }

    if (partnership === 'HYPE4TIM')
      return 'Hai completato la richiesta della carta TIMpersonal del minorenne.'

    return "Tieni d'occhio la tua email, riceverai presto informazioni sullo stato della tua richiesta"//'Hai completato la richiesta di registrazione del minorenne. La stiamo già processando!'
  }

  getInstructionsText() {
    const { partnership } = this.props.routing
    const { isParent, guid } = this.props

    if (partnership === 'HYPE4TIM') {
      if (!isParent) {
        if (!guid) {
          return "Tieni sott'occhio la tua email, ti invieremo a breve le istruzioni per proseguire."
        } else {
          return ''
        }
      } else {
        return 'La tua richiesta è completa, adesso tocca a noi. Presto invieremo al minorenne le istruzioni per proseguire.'
      }
    }

    return !isParent
      ? 'Iscriviti alla newsletter per non perdere nessuna opportunità di gestire in modo easy il tuo business'//"Tieni sott'occhio la tua email, ti invieremo a breve le istruzioni per proseguire."
      : 'Presto invieremo al minorenne le istruzioni per proseguire.'
  }
  backToSite(){
       window.open('https://www.axerve.com','_self')
  }
  render() {
    const { routing } = this.props

    if (!this.globalStylesOverrides) {
      this.globalStylesOverrides = css(this.props.styles.globals)
    }

    return (
      <Page>
        <Header
          centeredLogo={true}
          whiteLabel={!!routing.locationBeforeTransitions.query.embedded}
        />
        <Wrapper>
          <Title
            title={this.getTitleText()}
            subtitle={this.getSubtitleText()}
          />
          <div {...css(this.props.styles.container)}>
            <div {...css(this.props.styles['thank-you'])}>
              {/* <div {...css(this.props.styles['thank-you__text'])}>
                {this.getInstructionsText()}
              </div> */}
              <div {...css(this.props.styles['thank-you__img'])} />
              <div style={{ textAlign: 'center' }}>
              <Button
                id="bt-prev"
                text="TORNA AL SITO"
                action={() =>
                  this.backToSite()
                }
              />
              </div>
              <div
                {...css(
                  this.props.styles['thank-you__parent'],
                  !this.props.guid &&
                    this.props.styles['thank-you__parent--hidden']
                )}
              >
                <Title
                  title={'Sei con il tuo genitore?'}
                  subtitle={
                    'Clicca su continua e chiedigli di confermare la tua richiesta'
                  }
                />
                <div style={{ textAlign: 'center' }}>
                  {/*<Button text="Scarica l'app" action={() => this.setState({ guid: null })} type='primary'/><span style={{width:'50px', display: 'inline-block'}} />*/}
                  <Button
                    text="Continua"
                    action={() =>
                      pushRoute(`/resume/${routing.flow}/${this.props.guid}`)
                    }
                    type="primary"
                  />
                </div>
              </div>
            </div>
          </div>
          <Clearfix />
        </Wrapper>
        <Footer />
      </Page>
    )
  }
}

EndOfTheRide.propTypes = {
  guid: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  isParent: PropTypes.bool.isRequired,
  styles: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    guid: ownProps.params.guid,
    isParent: !!ownProps.location.query.p
  }
}

export default connect(mapStateToProps)(withStyles(Styles)(EndOfTheRide))



// WEBPACK FOOTER //
// ./containers/endOfTheRide/index.js